<script setup>
import { PermissionNames } from "~/configs/permission_names";
import { useProductStore } from "~/stores/productStore";
const handleCloseDialog = () => {
  productStore.setCreateModalVisibility(false);
};
const productStore = useProductStore();
</script>
<template>
  <div>
    <div
      v-if="isUserPermitted(PermissionNames.PRODUCT_CREATE)"
      class="cursor-pointer text-light-purple underline-light-purple- underline text-xs w-full flex justify-end dark:text-light-purple-bar"
      @click.prevent="productStore.setCreateModalVisibility(true)"
    >
      <el-tooltip content="Add Product" placement="top">
        <Svgs
          name="plus"
          class="w-5 h-5 text-light-sec-purple dark:text-white"
          stroke-width="1.2"
        />
      </el-tooltip>
    </div>

    <el-dialog
      v-model="productStore.showCreateModal"
      :before-close="handleCloseDialog"
      :lock-scroll="false"
      :modal="false"
      :show-close="true"
      :destroy-on-close="true"
      class="rounded-lg"
      draggable
      align-center
      width="35%"
    >
      <template #header="{ titleId, titleClass }">
        <div class="my-header flex flex-col gap-1">
          <h4 :id="titleId" class="text-md" :class="titleClass">
            Create Product
          </h4>
        </div>
      </template>
      <div class="subtext-dialog">
        <ProductsCreateForm :show-edit-modal-header="false" /></div
    ></el-dialog>
  </div>
</template>
